module.exports = __webpack_public_path__ + "img/tnb-logo.ad85d2a2.png";